"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
var _Translated = _interopRequireDefault(require("../Translated"));
var _SubscriptionForm = _interopRequireDefault(require("../SubscriptionForm"));
var _hooks = require("../../hooks");
var _config = require("../../../build/config");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const apiDomain = _config.apiBaseUrl.slice(0, -3);
const useStyles = (0, _core.makeStyles)(theme => (0, _core.createStyles)({
  main: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  mainLeft: {
    width: '40%',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center'
    },
    [theme.breakpoints.down('xs')]: {
      alignItems: 'flex-start'
    }
  },
  image: {
    width: '100%'
  },
  mainRight: {
    display: 'flex',
    justifyContent: 'flex-end',
    width: '50%',
    [theme.breakpoints.down('sm')]: {
      display: 'none'
    }
  }
}));
const SubscriptionMultiStepForm = _ref => {
  let {
    config,
    children,
    renderHeader,
    userId,
    ...props
  } = _ref;
  const classes = useStyles();
  const policyLinks = (0, _hooks.usePolicyLinks)();
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_core.Box, {
    mr: 8,
    ml: 8
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    paragraph: true,
    variant: "h5",
    component: "h4"
  }, config ? config.title : /*#__PURE__*/_react.default.createElement(_Translated.default, {
    id: "please_choose_subscription_plan"
  }))), config ? /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.main
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.mainLeft
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    color: "textSecondary",
    className: classes.textSecondary
  }, config.description)), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.mainRight
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: `${apiDomain}${config.image}`,
    className: classes.image,
    alt: "background"
  }))), /*#__PURE__*/_react.default.createElement(_core.Box, {
    textAlign: "center",
    mt: 3,
    mb: 2
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: classes.title
  }, /*#__PURE__*/_react.default.createElement(_Translated.default, {
    id: "subscription_template5_title"
  })))) : /*#__PURE__*/_react.default.createElement(_core.Box, {
    mr: 8,
    ml: 8
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    color: "textSecondary"
  }, /*#__PURE__*/_react.default.createElement(_Translated.default, {
    values: policyLinks,
    id: "subscription_plan_choice_description"
  }))), /*#__PURE__*/_react.default.createElement(_core.Box, {
    mt: 2
  }, /*#__PURE__*/_react.default.createElement(_SubscriptionForm.default, _extends({
    userId: userId
  }, props))));
};
var _default = exports.default = SubscriptionMultiStepForm;